import { View } from '@play-co/timestep-core/ui';
import StreakCloudPlatform from './StreakCloudPlatform';
import { streakBattleRoyaleTheme } from '../streakbattleroyale.theme';

const offsetX = 3;
const offsetY = -55;

export default class StreakCloudPlatforms extends View {
  public static OFFSET_A = 0.15;
  public platforms: StreakCloudPlatform[] = [];

  constructor(superview: View) {
    super({ superview });

    const { checkpoints, checkPointScales } =
      streakBattleRoyaleTheme().getMapConfig();

    for (let index = 0; index < checkpoints.length; index++) {
      const i = checkpoints.length - index - 1;
      const { x, y } = checkpoints[index];
      const scale = checkPointScales?.[index] ?? 1;

      const platform = new StreakCloudPlatform(
        {
          superview: this,
          x: x + offsetX,
          y: y + offsetY,
          scale,
          zIndex: i,
        },
        i * StreakCloudPlatforms.OFFSET_A,
      );

      this.platforms.push(platform);
    }
  }

  public getPlatform(index: number) {
    return this.platforms[index];
  }
}
